
import React from "react"
import { BrowserRouter, Switch, Route } from "react-router-dom"
import Navbar from "./components/Navbar/Navbar"
import Auth from "./components/Auth/Auth"
import Learn from "./components/Learn/Learn"
import Practice from "./components/Practice/Practice"
import Compete from "./components/Compete/Compete"
import Rss from "./components/Practice/Rss"
import Preferences from "./components/Preferences/Preferences"
import useStyles from "./styles"
import Options from "./components/Options/Options"
import PostHogPageviewTracker from "./PostHogPageviewTracker"

const App = () => {
    const classes = useStyles()
    return (
        <BrowserRouter>
            <PostHogPageviewTracker>
                <div className={classes.container}>
                    <Navbar />
                    <Switch>
                        <Route path="/" exact component={Options} />
                        <Route path="/Auth" exact component={Auth} />
                        <Route path="/Learn" exact component={Learn} />
                        <Route path="/Practice" exact component={Practice} />
                        <Route path="/Rss" exact component={Rss} />
                        <Route path="/Preferences" exact component={Preferences} />
                        <Route path="/Compete" exact component={Compete} />
                    </Switch>
                </div>
            </PostHogPageviewTracker>
        </BrowserRouter>
    )
}

export default App